import styled from 'styled-components';

export const MerchantOperationCostWrapper = styled.div``;
